import { OutletModel } from '@/models/outlet'

export const asyncFetchOutlet = () => {
  const $acl = useAclStore()
  const outletModel = new OutletModel()
  const outlet = ref<OutletType>()
  dataFetchList<OutletType>(outletModel, {
    filters: {
      OR: [
        // own outlet
        ...($acl.currentUser?.id ? [{ managerUserId: $acl.currentUser?.id }]: []),
        // assigned / referred outlet
        ...($acl.currentUser.outletId
          ? [
              { id: $acl.currentUser.outletId },
            ]
          : []),
      ],
    },
    page: 1,
    limit: 99,
    sorts: [
      {
        field: 'id',
        dir: 'asc',
      },
    ],
  }).then((resOutlet) => {
    // console.log('resOutlet', resOutlet)
    outlet.value = resOutlet.list.length > 0 ? resOutlet.list[0] : undefined
  })

  return {
    outlet
  }
}
